<template>
  <div class="h-topbar">
    <!-- 展开 -->
    <!-- <h-icon name="navicon"></h-icon> -->
    <!-- <span class="h-topbar-expandIcon-img"></span> -->
    <a href="/" class="topbar-logo-wrapper">
      <img src="~@/assets/index/logo.svg" width="125" height="36" alt="logo" @click.stop="gioTrackEvent('OP_headerLightLogoClick')"/>
    </a>
    <div class="h-topbar-tool" ref="topbarTool">
      <h-menu
        mode="horizontal"
        theme="dark"
        class="clearfix"
        @on-select="menuSelect"
      >
        <h-menu-item name="2">
          <div
            class="search-item search-hide"
            id="consoleSearch"
            ref="searchShow"
          >
            <div class="bg"></div>
            <div class="content">
              <input
                type="text"
                id="header-search-input"
                ref="searchInput"
                class="input"
                style="overflow: hidden"
                v-model="searchText"
                @keyup.enter="goSearch"
              />
              <div
                class="button"
                id="header-search-button"
                @click="showSearch"
              ></div>
            </div>
          </div>
          <!-- <h-menu-item name="2">
          <i class="search-btn" @click="showSearch"></i> -->
        </h-menu-item>
        <Submenu name="1">
          <template slot="title">
            <h-icon class="help-btn"></h-icon>
          </template>
          <a href="/openplat-doc/gtnDoc?docId=0336c82c808a41c6aea2bffc16c98b7a">
            <h-menu-item name="1-1">平台的政策与规范</h-menu-item>
          </a>
          <a href="/supportCM.html">
            <h-menu-item name="1-2">新手指引</h-menu-item>
          </a>
          <a href="/openplat-doc/gtnDoc?docId=1a2c03dc8334415da7977704d6a508a2">
            <h-menu-item name="1-3">购买指引</h-menu-item>
          </a>
          <a href="/openplat-doc/gtnDoc?docId=97078ddf0cde4c77ab89dbbc5e3c1efa">
            <h-menu-item name="1-3">开发者指引</h-menu-item>
          </a>
          <a href="/api.html">
            <h-menu-item name="1-3">API文档</h-menu-item>
          </a>
        </Submenu>
        <h-menu-item name="3">
          <span class="topbar-text"> {{ user.hideNickName }}</span>
        </h-menu-item>
        <Submenu name="2">
          <template slot="title">
            <h-icon class="person-btn"></h-icon>
          </template>
          <a href="/console/accountInfo.html">
            <h-menu-item name="2-1">基础信息</h-menu-item>
          </a>
          <a
            href="/console/salesCenter/serviceFiles.html"
            v-if="user.user_roles_code && user.user_roles_code[0] == 'sales'"
          >
            <h-menu-item name="2-2">销售中心</h-menu-item>
          </a>
          <!--<a href="/cloud/open/console/reseller/selectProduct.html">
            <h-menu-item name="2-1">商家中心</h-menu-item>
          </a>-->
          <a href="/cloud/open/netSign/billList.html">
            <h-menu-item name="2-3">费用账单</h-menu-item>
          </a>
          <h-menu-item name="2-4">退出登录</h-menu-item>
        </Submenu>
        <!-- <h-menu-item name="4">
          <span class="to-new-btn" @click="toNewConsole">返回旧版</span>
        </h-menu-item> -->
      </h-menu>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LockScreen from '@/components/LockScreen'
//import { changePwd,initMsg } from '@/api/login'
import { allToggleClass } from '@/utils'
export default {
  data() {
    // 新密码框校验

    // 确认密码框校验
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入您的新密码'))
      } else if (value !== this.setPassForm.newPassword) {
        callback(new Error('两次密码输入不一致'))
      } else {
        callback()
      }
    }
    return {
      searchText: '',
      showInput: false,
      setPassForm: {
        oldPassword: '',
        newPassword: '',
        newPasswordCheck: '',
      },
      validNewPassCheck: {
        validator: validatePassCheck,
        trigger: 'blur',
      },
      setPassword: false,
      submitLoading: true,
      locktime: this.LOCAL_CONFIG.LOCK_TIME,
      theme: this.LOCAL_CONFIG.THEME,
      sysName: this.LOCAL_CONFIG.SYS_NAME,
      appname: '',
      canPage: true,
      isComputed: false,
      appList: [
        {
          value: 'tip1',
          label: '搜索提示1',
        },
        {
          value: 'tip2',
          label: '搜索提示2',
        },
        {
          value: 'tip3',
          label: '搜索提示3',
        },
      ],
      allAppList: [],
      navWidth: 0,
      showMore: false,
      hideNavList: [],
    }
  },
  components: {
    LockScreen,
  },
  computed: {
    ...mapGetters(['permission_routers', 'menusRoot', 'user', 'activeIndex']),
    hideNavListLength() {
      return this.hideNavList.length
    },
  },
  watch: {
    theme() {
      allToggleClass(document.getElementsByTagName('html')[0], this.theme)
    },
    setPassword(val) {
      if (!val) {
        this.$refs.setPassForm.resetFields()
      }
    },
    hideNavListLength(val) {
      if (val > 0) {
        this.showMore = true
      } else {
        this.showMore = false
      }
    },
  },
  methods: {
    toNewConsole() {
      window.open(window.LOCAL_CONFIG.newConsoleHome)
    },
    goSearch() {
      this.gioTrackEvent('OP_validSearchBoxClick', {searchContent_var: this.searchText || '-' })
      window.location.href =
        '/openplat-front/searchResult?content=' + encodeURIComponent(this.searchText)
    },
    menuSelect(name) {
      let that = this
      if (name == '2-4') {
        this.$store.dispatch('Logout').then((res) => {
          //  
          localStorage.setItem('backUrl', window.location.href)
          this.$goLoginUrl()
          //window.location.href =
          //  window.location.origin + window.location.pathname + '/login'
        })
      }
    },
    showSearch() {
      if (this.$refs.searchShow.className.indexOf('search-hide') == -1) {
        //this.$refs.searchInput.style.width = '319px'
        this.$refs.searchShow.className = 'search-item search-hide'
      } else {
        //this.$refs.searchInput.style.width = 0
        this.$refs.searchShow.className = 'search-item search-active'
      }
    },
    hideSearch() {},
    handleShowInput() {
      this.showInput = !this.showInput
    },
    stopEvent($event) {
      $event.stopEvent()
      $event.preventDefault()
    },
    // 换肤
    handleChangeTheme(color) {
      this.theme = color
    },
    handleResetPass() {
      this.handleResetForm('setPassForm')
      this.setPassword = true
    },
    handleResetForm(name) {
      this.$refs[name].resetFields()
    },
    handleSetPassword() {
      this.$refs['setPassForm'].validate((valid) => {
        if (valid) {
          changePwd(this.setPassForm.oldPassword, this.setPassForm.newPassword)
            .then((res) => {
              // 服务端基础服务出错，实际已修改成功
              if (
                (res.data && res.data[this.LOCAL_CONFIG.SUCCESS_KEY] == '0') ||
                (res.data &&
                  res.data[this.LOCAL_CONFIG.SUCCESS_KEY] == '-1' &&
                  res.data.return_info == '获取基础业务框架服务失败')
              ) {
                this.setPassword = false
                this.$hMessage.success('重置密码成功!')
              } else {
                this.$hMessage.success(
                  '重置密码失败[' + res.data.return_info + ']'
                )
              }
            })
            .catch((error) => {
              this.$hMessage.info('网络通信失败,服务器异常')
            })
        } else {
          this.$hMessage.error('请正确填写密码!')
        }
      })
    },
    logout() {
      this.$store.dispatch('Logout').then(() => {
        location.reload()
      })
    },
    activeSidebar(index) {
      if (index >= 0) {
        this.$store.dispatch('ActiveRootIndex', index)
      }
      // let item = this.menusRoot[this.activeIndex]
      // 防止页面刷新时会跳转根页面
      // if(this.$route.matched[0].path !== item.url) {
      //   this.$router.push({path: item.url})
      // }
    },
    change(val) {
      // console.log(val)
    },
    scroll(num) {
      let _this = this
      if (num <= 1 && _this.canPage) {
        _this.canPage = false
        let length = _this.appList.length
        setTimeout(() => {
          let arr = _this.allAppList.slice(length, length + 10)
          if (arr.length > 0) {
            _this.appList = _this.appList.concat(arr)
            _this.canPage = true
          } else {
            this.isComputed = true
          }
        }, 200)
      }
    },
    computedNavWidth() {
      this.hideNavList = []
      if (this.$refs.topbarNav) {
        let logoWidth = this.$refs.topbarLogo
          ? this.$refs.topbarLogo.clientWidth
          : 0
        let toolWidth = this.$refs.topbarTool
          ? this.$refs.topbarTool.clientWidth
          : 0
        let searchWidth = this.$refs.topbarSearch
          ? this.$refs.topbarSearch.clientWidth
          : 0
        this.navWidth =
          document.getElementsByClassName('h-topbar')[0].clientWidth -
          logoWidth -
          toolWidth -
          searchWidth -
          20
        let that = this
        this.$nextTick(function () {
          // 对nav menu子元素从后往前遍历，将超出部分保存至hideNavList
          // menu总长度 that.$refs.topbarNav.children[0].children.length === that.menusRoot.length
          let menuRootWidth = document.getElementsByClassName(
            'h-topbar-navMenu'
          )[0].clientWidth
          // menu子元素
          let menuChildren = document.getElementsByClassName(
            'h-topbar-navMenu'
          )[0].children
          if (
            menuChildren &&
            menuChildren.length > 0 &&
            that.navWidth < menuRootWidth
          ) {
            for (let i = menuChildren.length - 1; i >= 0; i--) {
              if (that.navWidth < menuRootWidth) {
                that.hideNavList.splice(0, 0, that.menusRoot[i])
              } else {
                break
              }
              menuRootWidth = menuRootWidth - menuChildren[i].clientWidth
            }
          }
        })
      }
    },
  },
  created() {
    // 输入其他根目录下的路径时，切换sidebar
    if (this.menusRoot && this.menusRoot.length > 0) {
      if (this.$route.path.indexOf(this.menusRoot[this.activeIndex].url) < 0) {
        let urlArr = this.$route.path.split('/')
        let curUrl = '/' + urlArr[1]
        for (let [key, value] of this.menusRoot.entries()) {
          if (curUrl === value.url) {
            this.activeSidebar(key)
            return
          }
        }
      } else {
        // 更新对应的sidebar
        this.activeSidebar(this.activeIndex)
      }
    }
    //获取内部消息
    //initMsg();
    //setInterval(initMsg, 1000 * 60 * 5);// 5分钟轮询一次获取内部消息
  },
  mounted() {
    document.getElementsByTagName('html')[0].className = this.theme
    this.computedNavWidth()
    document.addEventListener('resize', this.computedNavWidth())
  },
}
</script>
<style lang="scss">
.h-menu-horizontal .h-menu-submenu .h-select-dropdown .h-menu-item {
  text-align: center;
}
.h-topbar-tool .h-menu-submenu:hover {
  border: 2px solid transparent;
}
.h-menu-light.h-menu-horizontal .h-menu-item-active,
.h-menu-light.h-menu-horizontal .h-menu-item:hover,
.h-menu-light.h-menu-horizontal .h-menu-submenu-active,
.h-menu-light.h-menu-horizontal .h-menu-submenu:hover {
  border-bottom: 2px solid transparent;
}
.h-menu-light.h-menu-horizontal
  .h-menu-submenu
  .h-select-dropdown
  .h-menu-item:hover {
  border-bottom: none;
}
.h-menu-light.h-menu-horizontal .h-menu-item,
.h-menu-light.h-menu-horizontal .h-menu-submenu {
  height: 60px;
  border: 2px solid transparent;
}
.h-menu-dark.h-menu-horizontal .h-menu-item,
.h-menu-dark.h-menu-horizontal .h-menu-submenu {
  border: 2px solid transparent;
}
.h-topbar .h-topbar-tool .icon-unfold:before {
  content: '';
}
.main-container .h-topbar-wrapper {
  position: fixed;
  top: 0;
}
.h-topbar {
  .topbar-text {
    color: #ffffff;
  }
  .icon-unfold:before {
    content: '';
  }
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .topbar-logo-wrapper {
    display: block;
    height: 60px;
    width: 153px;
    position: relative;
    left: 20px;
    img {
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      left: 50%;
    }
  }
}
.h-topbar-tool {
  height: 60px;
  .h-menu-horizonta {
    height: 60px;
  }
  .search-btn {
    width: 16px;
    height: 16px;
    background: url('~@/assets/console/search.png') no-repeat;
    margin: 0;
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    //float: left;
  }
  .search-btn:hover {
    width: 16px;
    height: 16px;
    background: url('~@/assets/console/search-active.png') no-repeat;
    margin: 0;
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    //float: left;
  }
  .help-btn {
    background: url('~@/assets/console/help-icon.png') no-repeat;
    width: 22px;
    height: 22px;
    display: inline-block;
    vertical-align: middle;
    border: none;
  }
  .help-btn:hover {
    background: url('~@/assets/console/help-active.png') no-repeat;
    width: 22px;
    height: 22px;
    display: inline-block;
    vertical-align: middle;
    border: none;
  }
  .person-btn {
    background: url('~@/assets/console/person-icon.png') no-repeat;
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: middle;
    border: none;
  }
}
.search-item {
  float: left;
  padding: 7px 10px;
  margin: 15px 20px 0 0;
  position: relative;
}

.search-item:hover .button {
  background: url('~@/assets/console/search-active.png') no-repeat;
}

.search-item input {
  border: none;
  float: left;
  color: #333;
  outline: 0;
}

.search-item .input {
  background-color: transparent;
  font-size: 12px;
  transition: width 0.5s linear;
  width: 0;
}

.search-item .button {
  width: 16px;
  height: 16px;
  background: url('~@/assets/console/search.png') no-repeat;
  margin: 0;
  cursor: pointer;
  float: left;
}

.search-item .button:hover {
  //background-position: 0 -26px
}

.search-item .button:active {
  -ms-background-position-x: 1px;
  -ms-background-position-y: -25px;
}

.search-item .bg {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  background: #e5e5e5;
  filter: alpha(opacity=40);
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  transition: opacity 0.5s linear;
}

.search-item .content {
  position: relative;
}

.search-active .button {
  background: url('~@/assets/console/search-active.png') no-repeat;
}

.search-active .button:active {
  -ms-background-position-x: 1px;
  -ms-background-position-y: -52px;
}

.search-active .input {
  padding: 0 4px;
  margin: 1px 0 0;
  line-height: 14px;
  width: 319px;
  transition: width 0.5s linear;
}
.search-hide .input {
  padding: 0 4px;
  margin: 1px 0 0;
  line-height: 14px;
  width: 0;
  transition: width 0.5s linear;
}

.search-active .bg {
  background-color: #fff;
  opacity: 1;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border-radius: 15px;
  transition: opacity 0.5 linear;
}
.search-hide .bg {
  opacity: 0;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border-radius: 15px;
}

.to-new-btn {
  display: inline-block;
  text-align: center;
  color: #703810;
  background:#FFCF37;
  border-radius: 16px;
  width: 88px;
  height: 28px;
  line-height: 28px;
  margin: 0 -20px 0 -20px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/consoleViews/bizFrame/Topbar.vue